var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ac817fd101ed63db36418bb28b98885705fa7fef"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tours@smartrent"]={id:"ac817fd101ed63db36418bb28b98885705fa7fef"};
      